import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reseller', {
        url: '/reseller',
        redirectTo: 'company.reseller.list',
        component: 'companyReseller',
        resolve: {},
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/reseller/reseller.state.js